import useFlag, { FLAGS } from "@coworker/app/src/hooks/useFlag";
import { useTranslation } from "@coworker/locales";
import { useState } from "react";
import { Navigate } from "react-router";
import Linkbar from "../../shared/components/Linkbar/Linkbar";
import FixaButton from "../../shared/wrappers/FixaButton/FixaButton";
import FixaLink from "../../shared/wrappers/FixaLink/FixaLink";
import { FixaText } from "../../shared/wrappers/FixaText/FixaText";
import { ExtractMediaModal } from "../components/ExtractMediaModal/ExtractMediaModal";
import { LaunchMediaFilters } from "../components/LaunchMediaFilters/LaunchMediaFilters";
import { MediaCard } from "../components/MediaCard/MediaCard";
import { UploadMediaModal } from "../components/UploadMediaModal/UploadMediaModal";
import {
  ACCEPTED_FILE_EXTENSIONS,
  ACCEPTED_MIME_TYPES,
  MAX_FILE_SIZE_BYTES,
} from "../config";
import styles from "./launch-media-page.module.css";
import { mediaCards } from "./mock-media";

const LaunchMediaPage = () => {
  const { t } = useTranslation();
  const [uploadMediaModalIsOpen, setUploadMediaModalIsOpen] = useState(false);
  const [extractMediaModalIsOpen, setExtractMediaModalIsOpen] = useState(false);
  const [uploadedFileName, setUploadedFileName] = useState("");

  const handleFilesSelected = (files: File[]) => {
    setUploadedFileName(files[0]?.name ?? "");
    setUploadMediaModalIsOpen(false);
    setExtractMediaModalIsOpen(true);
  };

  const enableLaunchMedia = useFlag(FLAGS.ENABLE_LAUNCH_MEDIA);
  if (!enableLaunchMedia) {
    return <Navigate to="/home" replace />;
  }

  return (
    <main className={styles["page"]}>
      <Linkbar currentLabel={t("capitalCaseLaunchMediaString")} />

      <FixaText tagName="h1" textStyle="Heading.L" className={styles["title"]}>
        {t("capitalCaseLaunchMediaString")}
      </FixaText>

      <div className={styles["filters-row"]}>
        <LaunchMediaFilters />

        <div className={styles["actions"]}>
          <FixaButton
            className={styles["trigger"]}
            htmlType="button"
            onClick={() => setUploadMediaModalIsOpen(true)}
            text={t("uploadString")}
            type="emphasised"
          />
          <UploadMediaModal
            isOpen={uploadMediaModalIsOpen}
            maxFileSizeBytes={MAX_FILE_SIZE_BYTES}
            acceptedFileExtensions={ACCEPTED_FILE_EXTENSIONS}
            acceptedMimeTypes={ACCEPTED_MIME_TYPES}
            onFilesSelected={handleFilesSelected}
            onClose={() => setUploadMediaModalIsOpen(false)}
          />
          <ExtractMediaModal
            fileName={uploadedFileName}
            isOpen={extractMediaModalIsOpen}
            onClose={() => setExtractMediaModalIsOpen(false)}
          />
        </div>
      </div>

      <FixaText
        tagName="p"
        textStyle="Heading.S"
        className={styles["results-count"]}
      >
        23 Results
      </FixaText>

      <section className={styles["grid"]} aria-label="Launch media">
        {mediaCards.map(
          ({
            id,
            imageUrl,
            imageAlt,
            badgeLabel,
            title,
            fiscalYear,
            mediaType,
            status,
            publishedDate,
          }) => (
            <FixaLink key={id} to={`/launch-media/${id}`}>
              <MediaCard
                id={id}
                imageUrl={imageUrl}
                imageAlt={imageAlt}
                badgeLabel={badgeLabel}
                title={title}
                fiscalYear={fiscalYear}
                mediaType={mediaType}
                status={status}
                publishedDate={publishedDate}
              />
            </FixaLink>
          )
        )}
      </section>
    </main>
  );
};

export default LaunchMediaPage;
